import React from "react";
import { useCurrentFrame, useVideoConfig } from "remotion";
import { WordTimestamp } from "../../types";

interface SolidCaptionsProps {
  subtitles: WordTimestamp[];
}

export const SolidCaptions: React.FC<SolidCaptionsProps> = ({ subtitles }) => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  const currentMs = (frame / fps) * 1000;

  // 1. Find the active word index
  let activeIndex = subtitles.findIndex(
    (sub) => currentMs >= sub.startMs && currentMs <= sub.endMs,
  );

  // If no word is perfectly active (e.g. slight pause between words),
  // find the last spoken word or default to 0
  if (activeIndex === -1) {
    const pastWords = subtitles.filter((sub) => sub.endMs <= currentMs);
    activeIndex = pastWords.length > 0 ? pastWords.length - 1 : 0;
  }

  // 2. Select a sliding rolling window of words to display (4 words)
  const wordsToShow = 4;
  const halfWindow = Math.floor(wordsToShow / 2);

  let startIdx = Math.max(0, activeIndex - halfWindow);
  const endIdx = Math.min(subtitles.length, startIdx + wordsToShow);

  // Adjust start index if we hit the end of the subtitle array
  if (endIdx - startIdx < wordsToShow && startIdx > 0) {
    startIdx = Math.max(0, endIdx - wordsToShow);
  }

  const visibleWords = subtitles.slice(startIdx, endIdx);

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        minHeight: "160px",
        margin: "30px 0",
        padding: "0 20px",
        zIndex: 10,
        textAlign: "center",
      }}
    >
      {visibleWords.map((sub, idx) => {
        const globalIdx = startIdx + idx;
        const isActive = globalIdx === activeIndex;

        return (
          <span
            key={`${sub.word}-${globalIdx}`}
            style={{
              display: "inline-block",
              fontFamily: "var(--font-title)",
              fontWeight: 900,
              fontSize: "40px", // Scaled down for perfect visual hierarchy under 54px takeaways
              textTransform: "uppercase",
              letterSpacing: "1.5px",
              margin: "6px 12px",
              padding: isActive ? "8px 24px" : "8px 12px",
              borderRadius: "14px",
              // Creator High-Impact solid backing capsule highlights!
              background: isActive ? "var(--accent-yellow)" : "transparent",
              color: isActive ? "#000000" : "rgba(255, 255, 255, 0.45)",
              boxShadow: isActive
                ? "0 8px 22px rgba(255, 209, 102, 0.4)"
                : "none",
              transform: isActive ? "scale(1.15) rotate(-2deg)" : "scale(1.0)",
              transition: "all 0.12s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
            }}
          >
            {sub.word}
          </span>
        );
      })}
    </div>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
